export default Object.freeze({
  Completed: 'COMPLETED',
  Discontinued: 'DISCONTIN',
  Enrolled: 'ENROLLED',
  Inactive: 'INACTIVE',
  Lapsed: 'LAPSED',
  Unconfirm: 'UNCONFIRM',
  Intermit: 'INTERMIT'
})
